import './buefy';
import './socketio';
import './vee-validate';
import './vue-meta';

export default {};
